import { render, staticRenderFns } from "./AddTransactionsList.vue?vue&type=template&id=6f94d957&scoped=true&"
import script from "./AddTransactionsList.vue?vue&type=script&lang=js&"
export * from "./AddTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./AddTransactionsList.vue?vue&type=style&index=0&id=6f94d957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f94d957",
  null
  
)

export default component.exports